import React, { useEffect, useState } from 'react';
import {Link} from 'react-router-dom';
import '../assets/css/sidebar.css';
import Dashboard from './Dashboard';
import { useSelector } from 'react-redux';
import FeatherIcon from 'feather-icons-react/build/FeatherIcon';

const Sidebar = ({url})=> {

	const [isDigitalArn,setIsDigitalArn] = useState(0);
	
	useEffect(()=>{
		let userVerif=JSON.parse(localStorage.getItem('userVerification'));
		setIsDigitalArn(userVerif?.is_digital_arn_candidate);
	},[]);

	return (
		<aside className="sidebar">
		  <ul>
		   {isDigitalArn == 1 ?  <li>
		      <Link>
		        <span className="icon home-icon"></span>
		      </Link>
		    </li> : <li className="active">
		      <Link to={url || "/dashboard"}>
		        <span className="icon home-icon"></span>
		      </Link>
		    </li>}

			{isDigitalArn == 1 ? <li className="active">
		      <Link>
				<i data-feather="bar-chart-2"><FeatherIcon icon="bar-chart-2"/></i>
		      </Link>
		    </li> : ""}
		    {/* <li className="">
		      <Link to="/">
		       <span className="icon candidate-form-icon"></span>     
		      </Link>
		    </li> */}
		  </ul>
		</aside>
	);
}

export default Sidebar;